import { rd } from '@passionware/monads';
import type { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import type { WithFeatureService } from 'v5/services/front/FeatureService/FeatureService';
import type { MergeServices } from 'v5/platform/ts/services';

/** Whether the `resource-pane` flag selects the v6 schema form. */
export function useIsResourcePaneV6(
  services: MergeServices<[WithFeatureService, WithAppScopeService]>
): boolean {
  const flag = services.featureService.useFeature(
    services.appScopeService.useResolvedScopeIdentity(),
    'resource-pane'
  );
  return rd.getOrElse(flag, 'v6') === 'v6';
}
